

/////////////////////////////////////////////////////////////////////////
// TIME HELPERS /////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const TimeHelpers =  {

  init: function(game) {

    this.game = game;  
  },
  
  makeOneShotTimer: function(delay, func, context) {

    var timer = this.game.time.create();
    //var args = [delay, func, context].concat(Array.prototype.slice.call(arguments, 3));

    timer.add.apply(timer, arguments);
    timer.start();

    return timer;
  }

};

export default TimeHelpers;



// WEBPACK FOOTER //
// ./app/src/utils/misc/TimeHelpers.js